import React, { useState } from "react";
// import GenImg from "./GenImg";

export class Genai extends React.Component {
  constructor(props) {
    super(props);
  }

  Fnavbar = () => {
    let Usernavbar = GenImg();
    return Usernavbar;
  };

  render() {
    return (
      // <React.Fragment>
      //   <this.Fnavbar />
      // </React.Fragment>

      <div style={{ paddingLeft: 200 }}>
        <h3>Welcome to Genai Enhance Images!</h3>
      </div>
    );
  }
}

export default Genai;
